import { Action } from './src/actions';
export type Action<T, P> = Action<T, P>;
export { actionCreator } from './src/actions';
export { createReducer } from './src/reducers';
